import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';


/**
 * The list of tabs on this page
 */
export enum AdmissionsProspectsPageTabId {
	Prospects = 1,
	Tab1 = 2,
	Tab2 = 3,
	Tab3 = 4,
}

/**
 * The list if main tab droplist views on this page
 */
export enum AdmissionsProspectsPageViewId {
	AllProspects = 1,
	AllApplications = 2,
	ClosedLeads = 3,
}


@Injectable({ providedIn: 'root' })
export class AdmissionsProspectsService extends PageTabsLayoutPageService<AdmissionsProspectsPageTabId, AdmissionsProspectsPageViewId> {

	private static readonly _viewDroplistItems: DroplistItem<never, AdmissionsProspectsPageViewId>[] = [
		{
			uniqueId: AdmissionsProspectsPageViewId.AllProspects, iconContext: {
				iconClass: 'fa-address-book',
				iconStyle: 'fa-solid',
				text: 'All Prospects',
				hideText: 'never',
			}, customSort: '1-All-Prospects'
		},
		{
			uniqueId: AdmissionsProspectsPageViewId.AllApplications, iconContext: {
				iconClass: 'fa-arrow-down-1-9',
				iconStyle: 'fa-solid',
				text: 'All Applications',
				hideText: 'never',
			}, customSort: '2-All-Applications'
		},
		{
			uniqueId: AdmissionsProspectsPageViewId.ClosedLeads, iconContext: {
				iconClass: 'fa-address-book',
				iconStyle: 'fa-solid',
				text: 'Closed Leads',
				hideText: 'never',
			}, customSort: '3-Closed-Leads'
		},
	];

	constructor() {
		super(AdmissionsProspectsService._viewDroplistItems, AdmissionsProspectsService.name, AdmissionsProspectsPageTabId.Prospects, AdmissionsProspectsPageViewId.AllProspects);
	}

	public get viewId() {
		return AdmissionsProspectsPageViewId;
	}




}